// client/src/coms/organisation/bookmarkActions.js
// "Save bookmark" from anywhere: saves to the account (server side), confirms with a toast that offers Undo
// and a shortcut to the bookmarks view. Nothing is cached in the browser, so accounts sharing a browser never
// see each other's bookmarks.
import { apiPostJson, apiDelete } from './orgApi';
import { notify, openArea } from './orgShared';

export async function saveBookmark(type, key, { note } = {}) {
  try {
    const r = await apiPostJson('/me/bookmarks', { target_type: type, target_key: String(key), ...(note ? { note } : {}) });
    const id = r && r.bookmark && r.bookmark.id;
    notify('Saved to bookmarks', {
      tone: 'success',
      action: id
        ? {
            label: 'Undo',
            onClick: () => apiDelete(`/me/bookmarks/${id}`).catch(() => {}),
          }
        : { label: 'View', onClick: () => openArea('bookmarks') },
    });
    try {
      window.dispatchEvent(new CustomEvent('vox-bookmarks-changed'));
    } catch {}
    return r && r.bookmark;
  } catch (e) {
    notify(e.status === 404 ? 'That item is no longer available.' : e.message || 'Could not save the bookmark', { tone: 'error' });
    return null;
  }
}
